import { localShareDate, type IShareExerciseItem, type WorkoutShareCardData } from './workoutShareData';

function performedSetLabel(exercise: IShareExerciseItem) {
  const values = exercise.setReps?.filter(value => Number.isFinite(value) && value > 0) || [];
  const low = values.length ? Math.min(...values) : Number(exercise.reps);
  const high = values.length ? Math.max(...values) : low;
  const reps = low === high ? String(low) : `${low}–${high}`;
  return `${exercise.sets} 组 × ${reps} ${exercise.repsUnit || '次'}`;
}

/** A completion receipt contains only performed work; samples in the design are never defaults. */
export function createCompletionPosterModel(data: WorkoutShareCardData) {
  const completed = data.completed !== false && data.totalSets > 0;
  const date = data.date || localShareDate();
  const exercises = data.exerciseList.filter(exercise => exercise.sets > 0);
  const rows = exercises.slice(0, 3).map(exercise => ({ name: exercise.name, detail: performedSetLabel(exercise) }));
  return {
    date: date.replaceAll('-', '.'), fileName: `练刻_训练凭证_${date}.png`,
    headline: completed ? '今日训练，已完成' : '本次训练，已记录',
    badge: completed ? '完成' : '已记录', dayName: data.dayName || '本次训练',
    metrics: [{ value: String(data.durationMin), unit: '分钟' },
      { value: String(data.exerciseCount), unit: '个动作' }, { value: String(data.totalSets), unit: '组' }],
    rows, listCaption: exercises.length > rows.length || data.exerciseCount > rows.length ? '动作清单节选' : '本次动作清单',
    caption: '今天的努力，已被记录', footer: completed ? 'TRAINING COMPLETED' : 'TRAINING RECORDED',
  };
}
export type CompletionPosterModel = ReturnType<typeof createCompletionPosterModel>;
